var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0537 3.80952H20.0061V13.3333H19.0537V16.1905C19.0537 16.7165 18.6273 17.1429 18.1013 17.1429H0.958484C0.432503 17.1429 0.00610352 16.7165 0.00610352 16.1905V0.95238C0.00610352 0.42639 0.432503 0 0.958484 0H18.1013C18.6273 0 19.0537 0.42639 19.0537 0.95238V3.80952ZM17.149 13.3333H11.4347C8.80478 13.3333 6.67276 11.2013 6.67276 8.57143C6.67276 5.94149 8.80478 3.80952 11.4347 3.80952H17.149V1.90476H1.91086V15.2381H17.149V13.3333ZM18.1013 11.4286V5.71428H11.4347C9.85668 5.71428 8.57754 6.99343 8.57754 8.57143C8.57754 10.1493 9.85668 11.4286 11.4347 11.4286H18.1013ZM11.4347 7.61905H14.2918V9.52381H11.4347V7.61905Z",
    fill: "#F5437E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSaved);
export default __webpack_public_path__ + "static/media/footerSaved.8a67b2aa6b8a0706c5321862996a65fb.svg";
export { ForwardRef as ReactComponent };